export enum FileInfoType {
  SOLVENCIA_ECONOMICA = 'SEF',
  SOLVENCIA_TECNICA = 'STP',
  ULTIMO_RESGARDO_IAE = 'IAE',
  DEPOSITO_FIANZA_PROVISIONAL = 'DGP',
  XUSTIFICANTE_ENTRADA_REXISTRO = 'XRA',
  OUTROS = 'OUT',
  ESCRITURA_CONSTITUCION = 'ECN',
  PODER_BASTANTE = 'POB',
  NIF_EMPRESA = 'NIFE',
  NIF_REPRESENTANTE = 'NIFR',
  ACREDITACION_CAPACIDADE_OBRAR = 'ACR'
}
